import React, { useState, useEffect } from 'react';
import './Home.css';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [

    { id: 0, image: '/images/abvig-launch.png', title: 'ABVIG Launch', description: 'The official launch of ABVIG - Connecting Africa to the World.', position: '50% 20%' },
    
    // New AICIS Images
    { id: 1, image: '/images/aicis-moses.jpeg', title: 'AICIS Summit', description: 'Hon. Moses O.T. Owharo at AICIS Summit.', position: '50% 20%' },
    { id: 2, image: '/images/aicis-osun.jpeg', title: 'AICIS with Osun State', description: 'AICIS engagement with Osun State Government.', position: '50% 20%' },
    { id: 3, image: '/images/aicis-board.jpeg', title: 'AICIS Board', description: 'AICIS Board of Directors and stakeholders.', position: '50% 20%' },
    { id: 4, image: '/images/aicis-audience.jpeg', title: 'AICIS Audience', description: 'Engaged audience at AICIS Summit.', position: '50% 20%' },
    { id: 5, image: '/images/aicis-with-osun-govn.jpeg', title: 'AICIS with Osun Governor', description: 'AICIS team with Osun State Governor.', position: '50% 20%' },
    { id: 6, image: '/images/aicis-with-osun-govns.jpeg', title: 'AICIS with Osun Governor', description: 'AICIS team with Osun State Governor.', position: '50% 20%' },
    { id: 7, image: '/images/aicis-with-osungovn.jpeg', title: 'AICIS with Osun Governor', description: 'AICIS team with Osun State Governor.', position: '50% 20%' },
    { id: 8, image: '/images/aicis022.jpeg', title: 'AICIS Summit', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 9, image: '/images/aicis033.jpeg', title: 'AICIS Summit', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    
    // Activities Images
    { id: 10, image: '/images/act-1.jpeg', title: 'AICIS Activities', description: 'Engaging activities at AICIS Summit.', position: '50% 20%' },
    { id: 11, image: '/images/act-2.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 12, image: '/images/act-3.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 13, image: '/images/act-4.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 14, image: '/images/act-5.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 15, image: '/images/act-6.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 16, image: '/images/act-7.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 17, image: '/images/act-8.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 18, image: '/images/act-9.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 19, image: '/images/act-10.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 20, image: '/images/act-11.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 21, image: '/images/act-12.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 22, image: '/images/act-13.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 23, image: '/images/act-14.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 24, image: '/images/act-15.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 25, image: '/images/act-16.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 26, image: '/images/act-17.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 27, image: '/images/act-18.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 28, image: '/images/act-19.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    { id: 29, image: '/images/act-20.jpeg', title: 'AICIS Activities', description: 'AICIS Summit activities and engagements.', position: '50% 20%' },
    
    // AICIS 2025 Images
    { id: 30, image: '/images/2025-1.jpeg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 31, image: '/images/2025-2.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 32, image: '/images/2025-3.jpeg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 33, image: '/images/2025-4.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 34, image: '/images/2025-5.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 35, image: '/images/2025-6.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 36, image: '/images/2025-7.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 37, image: '/images/2025-8.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    { id: 38, image: '/images/2025-9.jpg', title: 'AICIS 2025', description: 'AICIS 2025 Summit - Connecting Africa to the World.', position: '50% 15%' },
    
    // Original activities images
    { id: 39, image: '/images/aicisSummit_activities_01.jpg', title: 'Summit Opening Ceremony', description: 'The grand opening of AICIS Summit with distinguished guests and delegates from across the globe.', position: '50% 15%' },
    { id: 40, image: '/images/aicisSummit_activities_02.jpg', title: 'Investment Forum', description: 'High-level investment forum connecting global investors with African business opportunities.', position: '50% 20%' },
    { id: 41, image: '/images/aicisSummit_activities_03.jpg', title: 'Trade Mission', description: 'Delegates on a trade mission exploring business opportunities across the continent.', position: '50% 30%' },
    { id: 42, image: '/images/aicisSummit_activities_04.png', title: 'Board Meeting', description: 'Strategic board meeting with key stakeholders and decision-makers.', position: '50% 25%' },
    { id: 43, image: '/images/aicisSummit_activities_05.jpg', title: 'Networking Event', description: 'Networking session bringing together business leaders and industry experts.', position: '50% 20%' },
    { id: 44, image: '/images/aicisSummit_activities_06.png', title: 'Exhibition', description: 'Exhibition showcasing innovative products and solutions from across Africa.', position: '50% 30%' },
    { id: 45, image: '/images/aicisSummit_activities_07.jpg', title: 'Conference Session', description: 'Engaging conference sessions on climate change and infrastructure development.', position: '50% 15%' },
    { id: 46, image: '/images/aicisSummit_activities_08.jpg', title: 'Award Ceremony', description: 'Celebrating excellence with the AICIS awards ceremony recognizing outstanding contributions.', position: '50% 20%' },
    { id: 47, image: '/images/aicisSummit_activities_08 (1).jpg', title: 'Gala Dinner', description: 'Grand gala dinner celebrating the success of AICIS with dignitaries and delegates.', position: '50% 25%' },
    { id: 48, image: '/images/aicis26-05.jpg', title: 'AICIS 2026', description: 'AICIS 2026 preparations and activities.', position: '50% 25%' },
    { id: 49, image: '/images/aicis26-07.jpg', title: 'AICIS 2026', description: 'On 5th November 2025, Mr. Philip Okuabor and Dr. Oghogho Eleshin visited Primerose Towers, headquarters of FCMB in Lagos on behalf of ABVIG and presented the AICIS 2025 Award plaque to Mr. Obaro Odeghe, ED FCMB for their participation in the last summit.', position: '50% 25%' }
  ];

  const changeSlide = (direction) => {
    const newSlide = currentSlide + direction;
    if (newSlide < 0) {
      setCurrentSlide(slides.length - 1);
    } else if (newSlide >= slides.length) {
      setCurrentSlide(0);
    } else {
      setCurrentSlide(newSlide);
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 7000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div>
     
      <section className="hero-video-section">
        <video 
          className="hero-video" 
          autoPlay 
          loop 
          muted 
          playsInline
          poster="/images/hero-poster.jpg"
        >
          <source src="/video/hero-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>
            <span className="gold-text"></span>
            <span className="subtitle"></span>
          </h1>
          <p className="hero-description"></p>
        </div>
      </section>

      {/* AICIS 2026 Advertisement */}
      <section className="section-aicis-2026">
        <div className="aicis-hero" style={{backgroundImage: "url('/images/aicis-2026-bg.png')"}}>
          {/* Button removed from here */}
        </div>
        <div className="aicis-button-wrapper">
          <a 
            href="https://aicis2026.abvig.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="aicis-btn"
          >
            Secure Your Spot at AICIS 2026
          </a>
        </div>
      </section>

      {/* AICIS Activities - Slideshow */}
      <section className="section-activities-home">
        <div className="container">
          <h2 className="section-title">AICIS ACTIVITIES</h2>
          
          <div className="slideshow-container">
            <div className="slideshow-slide">
              <div 
                className="slideshow-image" 
                style={{
                  backgroundImage: `url(${slides[currentSlide].image})`,
                  backgroundPosition: slides[currentSlide].position || '50% 20%'
                }}
              ></div>
              <div className="slideshow-caption">
                <h3>{slides[currentSlide].title}</h3>
                <p>{slides[currentSlide].description}</p>
              </div>
            </div>

            {/* Navigation Buttons */}
            <button className="slideshow-btn prev" onClick={() => changeSlide(-1)}>❮</button>
            <button className="slideshow-btn next" onClick={() => changeSlide(1)}>❯</button>
          </div>

          {/* Dots Indicator */}
          <div className="slideshow-dots">
            {slides.map((_, index) => (
              <span 
                key={index} 
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </section>

      {/* Business & Investment Forum and Trade & Investment Mission - Side by Side */}
      <section className="section-forum-mission">
        <div className="container">
          <div className="forum-mission-grid">
            {/* Business & Investment Forum */}
            <div className="forum-card">
              <div className="forum-image" style={{backgroundImage: "url('/images/aicisMexicoCity.jpg')"}}></div>
              <div className="forum-content">
                <h3>BUSINESS & INVESTMENT FORUM</h3>
                <p>
                  Our platform is dedicated to fostering growth, sharing knowledge, and connecting entrepreneurs, investors, and industry leaders who are passionate about unlocking the potential of Africa's dynamic markets. Join us in major cities worldwide throughout the year, and be part of this transformative journey. Secure your spot today and make a lasting impact!
                </p>
                <button className="btn-gold" onClick={() => window.location.href='/business-forum'}>Join the Forum</button>
              </div>
            </div>

            {/* Trade & Investment Mission */}
            <div className="mission-card">
              <div className="mission-image" style={{backgroundImage: "url('/images/aisisInvestment.jpg')"}}></div>
              <div className="mission-content">
                <h3>PARTNERSHIP & COLLABORATION</h3>
                <p>
                  ABVIG and the AICIS Global Summit offer unparalleled opportunities for organizations to align with Africa's transformative journey. By partnering with us, you gain access to a network of government leaders, global investors, and industry pioneers dedicated to sustainable development and climate resilience.
                </p>
                <button className="btn-gold" onClick={() => window.location.href='/partnership-collaboration'}>Learn More</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Engage us for your Global Business needs */}
      <section className="section-services-home">
        <div className="container">
          <h2 className="section-title">Engage us for your Global Business needs</h2>
          <p className="subtitle-text">From real estate to natural minerals, healthcare to AI technology: the opportunities are endless.</p>
          
          <div className="services-home-grid">
            <div className="service-home-card">
              <h3>🏗️ REAL ESTATE & CONSTRUCTION</h3>
              <p>We facilitate acquisition of land, real estate development, and building administration. Our team of experts is dedicated to ensuring that your real estate needs are not only met, but exceeded.</p>
            </div>
            <div className="service-home-card">
              <h3>⛏️ NATURAL MINERALS, EXPORT & IMPORT</h3>
              <p>Discover the world's most precious natural minerals with ABVIG. We explore diamond, gold, copper, bauxite, and more with innovative methods that prioritize affordability, quality, and safety.</p>
            </div>
            <div className="service-home-card">
              <h3>🛢️ ENERGY, OIL, AND GAS</h3>
              <p>Our mission is clear: to promote the UN Energy goal and provide accessible and affordable global energy solutions. Join us in creating a brighter future for all. At ABVIG, we facilitate diverse and refined oil and gas products with unwavering commitment to safety and excellence.</p>
            </div>
            <div className="service-home-card">
              <h3>🏥 HEALTH CARE</h3>
              <p>Investing in healthcare in Africa is smart, socially responsible, and profitable. With growing demand for quality healthcare, there are ample opportunities for infrastructure, tech, and pharmaceutical investments. Make a positive impact while earning high returns - invest in Africa's healthcare future.</p>
            </div>
            <div className="service-home-card">
              <h3>💻 TECHNOLOGY & AI</h3>
              <p>Investing in technology and AI in Africa is a game-changer with vast untapped potential. From fintech to e-commerce and AI-powered solutions, the investment opportunities are enormous. By investing, you support the sector's growth and contribute to the continent's development.</p>
            </div>
          </div>
        </div>
      </section>

      {/* AICIS Board of Patrons */}
      <section className="section-patrons">
        <div className="container">
          <h2 className="section-title">AICIS Board of Patrons</h2>
          <div className="patrons-grid">
            <div className="patron-card">
              <div className="patron-image" style={{backgroundImage: "url('/images/king-alfred-diete-spiff.jpg')"}}></div>
              <h3>HRH. King Alfred Diete Spiff</h3>
              <p>Investitures As Of Africa Infrastructure, Climate Change & Investment On 3rd October 2023</p>
            </div>
            <div className="patron-card">
              <div className="patron-image" style={{backgroundImage: "url('/images/sidi-dauda-bage.jpg')"}}></div>
              <h3>HRH. Sidi Dauda Bage, Emir Of Lafia</h3>
              <p>Investitures As Of Africa Infrastructure, Climate Change & Investment On 3rd October 2023</p>
            </div>
            <div className="patron-card">
              <div className="patron-image" style={{backgroundImage: "url('/images/Faruk-Malami-Yabo.png')"}}></div>
              <h3>HE Faruk Malami Yabo, MFR</h3>
              <p>Investitures As Of Africa Infrastructure, Climate Change & Investment On 3rd October 2023</p>
            </div>
            <div className="patron-card">
              <div className="patron-image" style={{backgroundImage: "url('/images/dele-amuzienwa-odigbo.jpg')"}}></div>
              <h3>HRM Eze Prof. Dele Amuzienwa Odigbo</h3>
              <p>Chairman Imo State Oil Producing Areas Development Commission ISOPADEC Becomes Patron Of The Africa Infrastructure, Climate Change & Investment Summit (AICIS) 2023 Exhibition Scheduled For Washington - DC USA.</p>
            </div>
          </div>
        </div>
      </section>
  
        {/* Our Sectors of Trade */}
        <section className="section-sectors">
        <div className="container">
          <h2 className="section-title">Our Sectors of Trade</h2>
          <p className="subtitle-text">From real estate to natural minerals, healthcare to AI technology: the opportunities are endless.</p>
          
          <div className="sectors-grid">
            {/* Real Estate & Construction */}
            <div className="sector-card">
              <div className="sector-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&h=400&fit=crop')"}}></div>
              <div className="sector-content">
                <h3>REAL ESTATE & CONSTRUCTION</h3>
                <p>We facilitate acquisition of land, real estate development, and building administration. Our team of experts is dedicated to ensuring that your real estate needs are not only met, but exceeded.</p>
                <span className="sector-tag">Investing in real estate in Africa</span>
                <button className="btn-gold sector-btn" onClick={() => window.location.href='/services'}>LEARN MORE</button>
              </div>
            </div>

            {/* Natural Minerals, Export & Import */}
            <div className="sector-card">
              <div className="sector-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=600&h=400&fit=crop')"}}></div>
              <div className="sector-content">
                <h3>NATURAL MINERALS, EXPORT & IMPORT</h3>
                <p>Discover the world's most precious natural minerals with ABVIG. We explore diamond, gold, copper, bauxite, and more with innovative methods that prioritize affordability, quality, and safety.</p>
                <span className="sector-tag">Renewable energies in Africa</span>
                <button className="btn-gold sector-btn" onClick={() => window.location.href='/exports'}>LEARN MORE</button>
              </div>
            </div>

            {/* Energy, Oil, and Gas */}
            <div className="sector-card">
              <div className="sector-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1544644181-1484b3fdfc62?w=600&h=400&fit=crop')"}}></div>
              <div className="sector-content">
                <h3>ENERGY, OIL, AND GAS</h3>
                <p>Our mission is clear: to promote the UN Energy goal and provide accessible and affordable global energy solutions. Join us in creating a brighter future for all. At ABVIG, we facilitate diverse and refined oil and gas products with unwavering commitment to safety and excellence.</p>
                <span className="sector-tag">Oil rig in Africa</span>
                <button className="btn-gold sector-btn" onClick={() => window.location.href='/services'}>LEARN MORE</button>
              </div>
            </div>

            {/* Healthcare */}
            <div className="sector-card">
              <div className="sector-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=600&h=400&fit=crop')"}}></div>
              <div className="sector-content">
                <h3>HEALTHCARE</h3>
                <p>Investing in healthcare in Africa is smart, socially responsible, and profitable. With growing demand for quality healthcare, there are ample opportunities for infrastructure, tech, and pharmaceutical investments. Make a positive impact while earning high returns - invest in Africa's healthcare future.</p>
                <span className="sector-tag">AI advancements in Africa</span>
                <button className="btn-gold sector-btn" onClick={() => window.location.href='/vip-services'}>LEARN MORE</button>
              </div>
            </div>

            {/* Technology & AI */}
            <div className="sector-card">
              <div className="sector-image" style={{backgroundImage: "url('https://images.unsplash.com/photo-1535378917042-10a22c95931a?w=600&h=400&fit=crop')"}}></div>
              <div className="sector-content">
                <h3>TECHNOLOGY & AI</h3>
                <p>Investing in technology and AI in Africa is a game-changer with vast untapped potential. From fintech to e-commerce and AI-powered solutions, the investment opportunities are enormous. By investing, you support the sector's growth and contribute to the continent's development.</p>
                <span className="sector-tag">Tech innovation in Africa</span>
                <button className="btn-gold sector-btn" onClick={() => window.location.href='/services'}>LEARN MORE</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;